import React, { useEffect, useRef, useState } from "react"
import { FormFeedback, Input, Label } from "reactstrap"
import DefaultAppLogo from '../../../assets/images/lystfacelogos/DefaultAppLogo.svg'
import CustomLoader from "../../../components/Common/CustomLoader"
import ProfileImageIcon from '../../../assets/images/lystfacelogos/ProfileImageIcon.svg'
import { imageValidation } from "../../../config"
import { resetApplicationResponseMsg } from "../../../store/menu/application/actions"
import { useDispatch, useSelector } from "react-redux"
import { copyToClipBoardNewIcon, DeleteIcon, EditIcon } from "../../../components/Common/SvgIcons"
import RightSideModal from "../../../components/Common/RightSideModal"
import ProfileUpdate from "./ProfileUpdate"



const ApplicationDescription = ({ validationType, handlePhotoUplaod, applicationStatus, app, handleClickGenerateKey, regeneratedAppKey, generateApikeyLoading, handleDeleteIcon, appIcon, fileInputKey, setCroppedImage, setFileInputKey, isremoved, croppedImage, validationMessage, setValidationMessage }) => {
    const appIdRef = useRef();
    const appKeyRef = useRef();
    const { allowedFormats } = imageValidation
    const formatsList = allowedFormats.map((format) => `${format}`).join(",")
    const dispatch = useDispatch();
    const [keyCopied, setKeyCopied] = useState(false)
    const [popupDetails, setPopupDetails] = useState({ open: false })
    const cropperRef = useRef(null);
    const [isDisabled, setIsDisabled] = useState(false);

    useEffect(() => {
        if (croppedImage && validationType.values.cropIcon) {
            validationType.setFieldValue("appIcon", validationType.values.cropIcon)
        }
    }, [croppedImage])

    useEffect(() => {
        if (keyCopied) {
            setTimeout(() => {
                dispatch(resetApplicationResponseMsg({ from: 'regeneratedAppKey' }))
            }, 1000);
        }
    }, [keyCopied])




    const handleCopyAppDetails = (e) => {
        let ref = null;
        const name = e.currentTarget.getAttribute('data-name');

        if (name === 'appKey') {
            ref = appKeyRef.current.innerText;
        } else {
            ref = appIdRef.current.innerText;
        }

        const textarea = document.createElement('textarea');
        textarea.value = ref;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        document.body.removeChild(textarea);

        const copyText = document.getElementById(name);
        copyText.textContent = "Copied.";
        setTimeout(() => {
            copyText.textContent = "";
        }, 10000);
    }

    const handleCopyAppDetailsKey = (e) => {
        let ref = null
        const name = e.currentTarget.getAttribute('data-name');
        if (name === 'appKey') {
            ref = appKeyRef.current.innerText

        }
        ref = appKeyRef.current.innerText

        const textarea = document.createElement('textarea');
        const copyText = document.getElementById(name)
        textarea.value = ref;
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand('copy');
        copyText.textContent = "Copied.";
        document.body.removeChild(textarea);
        setTimeout(() => {
            copyText.textContent = "";
        }, 2000);
        setKeyCopied(true)
    }

    function base64ToFile(base64String, fileName) {
        const arr = base64String.split(',');
        const mime = arr[0].match(/:(.*?);/)[1];
        const bstr = atob(arr[1]);
        let n = bstr.length;
        const u8arr = new Uint8Array(n);

        while (n--) {
            u8arr[n] = bstr.charCodeAt(n);
        }

        return new File([u8arr], fileName, { type: mime });
    }

    const handleClickPrimaryButton = (validationType) => {

        if (cropperRef.current) {
            let imageURL = cropperRef?.current?.src
            if (!imageURL.startsWith('https')) {
                const croppedCanvas = cropperRef.current.cropper.getCroppedCanvas();
                const croppedFile = base64ToFile(croppedCanvas.toDataURL(), 'cropped_image.png');
                validationType.setFieldValue("appIconFile", croppedFile)
                setCroppedImage(croppedCanvas.toDataURL());
            }


        }
        else {
            setCroppedImage(null)
            handleDeleteIcon();


        }
        setPopupDetails({ open: false })

    }

    const handleClickSecondaryButton = () => {
        setPopupDetails({ open: false })
        validationType.setFieldValue("cropIcon", "")
        validationType.setFieldValue("appIconFile", "")
        setFileInputKey(Date.now());



    }



    const handleEditIcon = () => {
        setPopupDetails({
            open: true, titleText: `${(croppedImage || appIcon) ? 'Edit Image' : 'Add Image'}`, title: validationType, bodyText: 'You have unsaved changes in this page. Are you sure you want to discard?', primaryButtonText: 'Save', secondaryButtonText: 'Cancel', handleClickSecondaryButton: handleClickSecondaryButton, handleClickPrimaryButton: handleClickPrimaryButton, handleClose: handleClickSecondaryButton
        })
    }

    const handleBrowseFiles = (from) => {
        document.getElementById("profile-upload").click()

    }
    return (
        <>
            <div>
                <Label htmlFor="profile-picture" className={`${applicationStatus !== "manage" ? "custom-file-upload" : "manage-file-upload"}`}>
                    <div className={`${(!croppedImage && !appIcon) ? applicationStatus !== "manage" ? "account-profile-name-edit-view" : "account-profile-name" : "img-wrap"}`}>
                        {(!croppedImage && !appIcon && validationType.values.appName) ?
                            <>
                                <span >{validationType.values.appName.charAt(0).toUpperCase()}</span>
                                <div class="profile-hover-overlay" onClick={handleEditIcon}>
                                    <div className="profile-action">
                                        {(croppedImage || appIcon) ? "Edit" : "Add"}
                                    </div>
                                </div>
                            </>
                            :
                            <>
                                <img
                                    className={`profile-img ${applicationStatus !== "manage" ? croppedImage || appIcon ? "" : "image-placeholder" : ""}`}
                                    src={croppedImage ? croppedImage : appIcon ? appIcon : ProfileImageIcon}
                                />
                                <div class="profile-hover-overlay" onClick={handleEditIcon}>
                                    <div className="profile-action">
                                        {(croppedImage || appIcon) ? "Edit" : "Add"}
                                    </div>
                                </div>
                            </>
                        }

                    </div>

                    {applicationStatus !== "manage" &&
                        <Input
                            id="profile-upload"
                            type="file"
                            onChange=
                            {(e) => handlePhotoUplaod(e)}
                            onBlur={validationType.handleBlur}
                            readOnly={applicationStatus === "manage" ? true : false}
                            accept={formatsList}
                            key={fileInputKey}
                        />}
                </Label>
                {validationType.touched.appIcon && validationType.errors.appIcon ? (
                    <FormFeedback type="invalid" className="d-block">
                        {validationType.errors.appIcon}
                    </FormFeedback>
                ) : null}
                <div className="app-form-fields-container">
                    <div className="form-input-container">
                        <Label className={`${applicationStatus === "manage" ? "form-manage-title" : "form-input-title"}`}>
                            App name<span className="text-danger"> *</span>
                        </Label>
                        <Input
                            name="appName"
                            className={`${applicationStatus === "manage" ? "form-manage-input" : "form-input"}
                        ${validationType.touched.appName && validationType.errors.appName
                                    ? `border-danger`
                                    : ``
                                }
                            `}
                            formNoValidate={true}
                            type="text"
                            onChange={validationType.handleChange}
                            onBlur={validationType.handleBlur}
                            value={validationType.values.appName.trimStart() || ""}
                            readOnly={applicationStatus === "manage" ? true : false}
                        />
                        {validationType.touched.appName && validationType.errors.appName ? (
                            <FormFeedback type="invalid" className="d-block">
                                {validationType.errors.appName}
                            </FormFeedback>
                        ) : null}
                    </div>
                    <div className="gap"></div>
                    <div className={`form-input-container`}>
                        <Label className={`${applicationStatus === "manage" ? "form-manage-title" : "form-input-title"}`}>
                            App description
                        </Label>
                        <Input
                            name="appDescription"
                            className={`${applicationStatus === "manage" ? "form-manage-input" : "form-input"}
                        ${validationType.touched.appDescription && validationType.errors.appDescription
                                    ? `border-danger`
                                    : ``
                                }
                            `}
                            formNoValidate={true}
                            type="text"
                            onChange={validationType.handleChange}
                            onBlur={validationType.handleBlur}
                            value={applicationStatus === "manage" ? validationType.values.appDescription.trimStart() || "-" : validationType.values.appDescription.trimStart() || ""}
                            readOnly={applicationStatus === "manage" ? true : false}

                        />

                        {validationType.touched.appDescription && validationType.errors.appDescription ? (
                            <FormFeedback type="invalid" className="d-block">
                                {validationType.errors.appDescription}
                            </FormFeedback>
                        ) : null}
                    </div>
                </div >
                {
                    applicationStatus !== "create" ?
                        <>
                            <div className="line-break" />

                            <div className="card-header-container">
                                <span className="title">API management</span>
                            </div>
                            <div className="app-key-fields-container">
                                <div className="form-input-container">
                                    <span className="key-label">App ID</span>
                                    <div className="copy-key-container">
                                        <span className="app-key" ref={appIdRef} >{app?.app_id}</span>
                                        <div onClick={(e) => handleCopyAppDetails(e)} data-name="appId" className="copy-icon">
                                            <span className="copied-text" id="appId"></span>
                                            {copyToClipBoardNewIcon}

                                        </div>

                                    </div>

                                </div>
                                <div className="gap"></div>
                                <div className="form-input-container">
                                    <span className="key-label">App key</span>
                                    <div className="copy-key-container">
                                        {
                                            generateApikeyLoading ?
                                                <CustomLoader text="Generating new app key...." />
                                                :
                                                regeneratedAppKey.length > 0 && !generateApikeyLoading ?
                                                    <>
                                                        <span className="app-key" ref={appKeyRef}>{regeneratedAppKey}</span>
                                                        <div data-name="appKey" className="copy-icon" onClick={(e) => { handleCopyAppDetailsKey(e) }}>
                                                            <span className="copied-text" id="appKey"></span>
                                                            {copyToClipBoardNewIcon}
                                                        </div>
                                                    </>


                                                    :
                                                    <span className='key-button' onClick={() => {
                                                        setKeyCopied(false)
                                                        handleClickGenerateKey();
                                                    }}>Generate new app key</span>
                                        }
                                    </div>

                                </div>
                            </div>
                        </>
                        :
                        <div className="key-container">
                            {/* <div className="api-key">
                            <span>API key</span>

                        </div>
                        <div className="generate-key-section">
                            <div className="key-image">
                                <img src={keyImage} />

                            </div>
                            <div className="title">
                                <span >
                                    Generate your first API key
                                </span>

                            </div>
                            <div>
                                <button className="button">Generate new API key</button>
                            </div>

                        </div> */}
                        </div>
                }

            </div >
            {
                popupDetails.open &&
                <RightSideModal
                    popupDetails={popupDetails}
                    primaryButtonDisabled={isDisabled}
                >
                    <ProfileUpdate handleEditClick={handleBrowseFiles} handlePhotoUplaod={handlePhotoUplaod} image={validationType?.values?.cropIcon ? validationType?.values?.cropIcon : validationType?.values?.appIcon ? validationType?.values?.appIcon : appIcon ? appIcon : null} cropperRef={cropperRef} handleDeleteClick={handleDeleteIcon} validationType={validationType} setFileInputKey={setFileInputKey} isremoved={isremoved} isCdnImage={(validationType?.values?.cropIcon || validationType?.values?.appIcon) ? false : true} setIsDisabled={setIsDisabled} updatedImage={validationType?.values?.appIcon ? validationType?.values?.appIcon : appIcon ? appIcon : null} croppedImage={croppedImage} validationMessage={validationMessage} setValidationMessage={setValidationMessage} />
                </RightSideModal>
            }
        </>
    )
}

export default ApplicationDescription
